import { useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';

import {
	ModelOfMovimentationDemandRequest,
	ModelOfMovimentationDemand,
	ModelOfMovimentationRequest,
} from '../../database/index';

import { useAuth } from 'src/contexts/auth';
import api from '../../services/api';
import { useListProductsController } from '../Products/ListProductsController';
import { useListUserController } from '../User/ListUserController';
import { useListDriversController } from '../Driver/ListDriversController';
import { useData } from 'src/contexts/data';

interface PersonCpfProps {
	PESSOA: string;
	NOME: string;
	DATANASCIMENTO: string;
}

export const useFormCreateMovimentation = () => {
	const { getProductListController } = useListProductsController();
	const { getUserListController } = useListUserController();
	const { getDriverListController } = useListDriversController();

	const { vehicleDataSelected } = useData();
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState<boolean>(false);
	const [DemandResponse, setDemandResponse] = useState<AxiosResponse | null>(null);
	const [PersonCpf, setPersonCpf] = useState<PersonCpfProps[]>([{ PESSOA: '', NOME: '', DATANASCIMENTO: '' }]);
	const [loadingPersonCpf, setLoadingPersonCpf] = useState(false);
	const [foundPersonCpf, setFoundPersonCpf] = useState(false);

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		ORGAOUNIDADEDESTINO: Yup.string().required('* Campo obrigatório'),
		AX_PRODUTO: Yup.string().required('* Campo obrigatório'),
		QUANTIDADEAUTORIZADA: Yup.string().required('* Campo obrigatório'),
		PESSOADESTINO: Yup.string().required('* Campo obrigatório'),
		PESSOAORIGEM: Yup.string().required('* Campo obrigatório'),
		DATAEFETIVADA: Yup.string().required('* Campo obrigatório'),
	});

	const handleFindInfo = (field?: string, id?: string) => {
		if (field === 'AX_PRODUTO') {
			let item = getProductListController.allProductsData.find(product => {
				return product.ID === id;
			});
			formik.setFieldValue('PRECOCUSTO', item?.ULTIMOVALORCOMPRA);
			formik.setFieldValue('PRECOVENDA', item?.ULTIMOVALORVENDA);
			formik.setFieldValue('AX_ESTOQUE', item?.AX_ESTOQUE);
			formik.setFieldValue('AX_PRODUTO', item?.ID);
		}

		if (field === 'PESSOAORIGEM') {
			let itemUser = getUserListController.AllUserData.find(user => {
				return user.PESSOA === id;
			});
			formik.setFieldValue('FT_USUARIOORIGEM', itemUser?.ID);

			let itemDriver = getDriverListController.allDriversData.find(driver => {
				return driver.PESSOA === id;
			});
			formik.setFieldValue('FT_MOTORISTA', itemDriver?.ID);
		}

		if (field === 'PESSOADESTINO') {
			let itemUser = getUserListController.AllUserData.find(user => {
				return user.PESSOA === id;
			});
			formik.setFieldValue('FT_USUARIODESTINO', itemUser?.ID);
		}
	};

	const saveMovimentationDemand = async (MovimentationDemandRequest: ModelOfMovimentationDemandRequest) => {
		const newMovimentationDemand: ModelOfMovimentationDemand = {
			PESSOAORIGEM: MovimentationDemandRequest.PESSOAORIGEM,
			PESSOADESTINO: MovimentationDemandRequest.PESSOADESTINO,
			ORGAOUNIDADEDESTINO: MovimentationDemandRequest.ORGAOUNIDADEDESTINO,
			FT_USUARIO: MovimentationDemandRequest.FT_USUARIOORIGEM,
			FT_VEICULO: vehicleDataSelected?.ID,
			ORGAO: userAgencyId,
			DESCRICAO: 'RETROATIVA',
			TIPODEMANDA: 0,
			PRIORIDADE: '7c820dfd-4ced-4b7b-a4f7-1db116df6f17',
		};

		const newMovimentationRequest: ModelOfMovimentationRequest = {
			ORGAO: userAgencyId,
			PESSOA: MovimentationDemandRequest.PESSOADESTINO,
			DESCRICAO: 'RETROATIVO',
			QUANTIDADEITEM: 1,
			FT_USUARIO: MovimentationDemandRequest.FT_USUARIODESTINO,
			FT_VEICULO: vehicleDataSelected?.ID,
			FT_MOTORISTA: MovimentationDemandRequest.FT_MOTORISTA,
			ITINERARIO: 'RETROATIVO',
			MOTIVOVIAGEM: 'RETROATIVO',
			QUANTIDADECOMBUSTIVELSOLICITADO: MovimentationDemandRequest.QUANTIDADEAUTORIZADA,
			QUANTIDADEAUTORIZADA: MovimentationDemandRequest.QUANTIDADEAUTORIZADA,
			STATUS: 0,
			PRIORIDADE: '7c820dfd-4ced-4b7b-a4f7-1db116df6f17',
			PRECOCUSTO: MovimentationDemandRequest.PRECOCUSTO,
			PRECOVENDA: MovimentationDemandRequest.PRECOVENDA,
			AX_PRODUTO: MovimentationDemandRequest.AX_PRODUTO,
			AX_ESTOQUE: MovimentationDemandRequest.AX_ESTOQUE,
		};

		api.post('demands', newMovimentationDemand)
			.then(responseDemand => {
				setDemandResponse(responseDemand);
				api.post('request', {
					...newMovimentationRequest,
					DEMANDA: responseDemand.data.ID,
				})
					.then(response => {
						let dataResponse = response.data;
						api.put(`request-items/${dataResponse.REQUISICAOITEM.ID_REQUISICAOITEM}`, {
							AX_REQUISICAO: dataResponse.REQUISICAO.ID_REQUISICAO,
							AX_PRODUTO: dataResponse.REQUISICAOITEM.AX_PRODUTO,
							QUANTIDADECOMBUSTIVELSOLICITADO: MovimentationDemandRequest.QUANTIDADEAUTORIZADA,
							QUANTIDADEAUTORIZADA: MovimentationDemandRequest.QUANTIDADEAUTORIZADA,
							VEICULOKM: MovimentationDemandRequest.VEICULOKM,
							QUANTIDADEEFETIVADA: MovimentationDemandRequest.QUANTIDADEAUTORIZADA,
							DATAEFETIVADA: moment(MovimentationDemandRequest.DATAEFETIVADA, 'DD/MM/YYYY')
								.toDate()
								.toLocaleDateString('en', {
									year: 'numeric',
									month: '2-digit',
									day: '2-digit',
								}),
							STATUS: 0,
							DEMANDA: responseDemand.data.ID,
							CREDOR: '',
						})
							.then(() => {
								toast.current.show({
									severity: 'success',
									summary: 'Cadastro realizado',
									detail: 'Operação realizada com sucesso!',
									life: 5000,
								});
								setLoading(false);
							})
							.catch(err => {
								setLoading(false);
								toast.current.show({
									severity: 'error',
									summary: 'Cadastro não realizado',
									detail: 'Falha ao realizar operação!',
									life: 5000,
								});
							});
					})
					.catch(() => {
						setLoading(false);
						toast.current.show({
							severity: 'error',
							summary: 'Cadastro não realizado',
							detail: 'Falha ao realizar operação!',
							life: 5000,
						});
					});
			})
			.catch(err => {
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Cadastro não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const searchPersonCpf = async (cpf: string, field: string) => {
		setLoadingPersonCpf(true);
		const response = await api.post('people/get-person', { CPF: cpf });

		if (response.data.length) {
			setPersonCpf(response.data);
			formik.setFieldValue(field, response.data[0].ID);
			handleFindInfo(field, response.data[0].ID);
		}

		setFoundPersonCpf(!!response.data[0]);
		setLoadingPersonCpf(false);
	};

	const formik = useFormik<ModelOfMovimentationDemandRequest>({
		initialValues: {
			PESSOAORIGEM: '',
			PESSOADESTINO: '',
			ORGAOUNIDADEDESTINO: '',
			FT_USUARIOORIGEM: '',
			FT_USUARIODESTINO: '',
			FT_VEICULO: '',
			VEICULOKM: 0,
			ORGAO: '',
			DESCRICAO: '',
			TIPODEMANDA: 0,
			PRIORIDADE: '',
			QUANTIDADEITEM: 0,
			FT_MOTORISTA: '',
			ITINERARIO: '',
			MOTIVOVIAGEM: '',
			QUANTIDADECOMBUSTIVELSOLICITADO: 0,
			QUANTIDADEAUTORIZADA: 0,
			STATUS: 0,
			PRECOCUSTO: 0,
			PRECOVENDA: 0,
			AX_PRODUTO: '',
			AX_ESTOQUE: '',
		},
		onSubmit: async values => await saveMovimentationDemand(values),
		validationSchema,
	});

	return {
		getDemandFormController: {
			formik,
			loading,
			toast,
			DemandResponse,
			loadingPersonCpf,
			foundPersonCpf,
			PersonCpf,
		},
		handleDemandFormController: {
			setDemandResponse,
			handleFindInfo,
			searchPersonCpf,
			setFoundPersonCpf,
		},
	};
};
